/** Définitions navigation (clés i18n `nameKey`, identifiant stable `id`). */
export const MAIN_NAV_DEFS = [
  {
    id: 'dashboard',
    nameKey: 'nav.dashboard',
    href: '/dashboard',
    icon: 'M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6',
    permission: 'dashboard.view',
    route: '/',
  },
  {
    id: 'members',
    nameKey: 'nav.members',
    href: '/members',
    icon: 'M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z',
    permission: ['members.view', 'members.view_own'],
    route: '/members',
  },
  {
    id: 'contributions',
    nameKey: 'nav.contributions',
    href: '/contributions',
    icon: 'M17 9V7a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2m2 4h10a2 2 0 002-2v-6a2 2 0 00-2-2H9a2 2 0 00-2 2v6a2 2 0 002 2zm7-5a2 2 0 11-4 0 2 2 0 014 0z',
    permission: ['contributions.view', 'contributions.view_own'],
    route: '/contributions',
  },
  {
    id: 'allocations',
    nameKey: 'nav.allocations',
    href: '/assistance',
    icon: 'M12 8c-2.21 0-4 1.79-4 4v1H6a2 2 0 00-2 2v1h16v-1a2 2 0 00-2-2h-2v-1c0-2.21-1.79-4-4-4zm-2 5v-1a2 2 0 114 0v1h-4z',
    permission: ['contributions.view', 'contributions.view_own'],
    route: '/support',
  },
  {
    id: 'finances',
    nameKey: 'nav.finances',
    href: '/my-fund/financial',
    icon: 'M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z',
    permission: ['financial.view', 'financial.view_own'],
    route: '/financial',
  },
  {
    id: 'documents',
    nameKey: 'nav.documents',
    href: '/documents',
    icon: 'M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z',
    permission: ['documents.view', 'documents.view_public'],
    route: '/documents',
  },
  {
    id: 'calendar',
    nameKey: 'nav.calendar',
    href: '/calendar',
    icon: 'M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z',
    permission: ['events.view', 'events.view_public'],
    route: '/calendar',
  },
];

export const SAAS_ADMIN_NAV_DEFS = [
  {
    id: 'saas_dashboard',
    nameKey: 'nav.admin.saasDashboard',
    href: '/saas',
    icon: 'M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6',
    permission: null,
    route: '/saas',
    saasOnly: true,
  },
  {
    id: 'saas_orgs',
    nameKey: 'nav.admin.organizations',
    href: '/saas/organizations',
    icon: 'M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4',
    permission: null,
    route: '/saas/organizations',
    saasOnly: true,
  },
];

export const ADMIN_NAV_DEFS = [
  {
    id: 'users',
    nameKey: 'nav.admin.users',
    href: '/users',
    icon: 'M12 4.354a4 4 0 110 5.292M15 21H3v-1a6 6 0 0112 0v1zm0 0h6v-1a6 6 0 00-9-5.197M13 7a4 4 0 11-8 0 4 4 0 018 0z',
    permission: 'users.view',
    route: '/users',
  },
  {
    id: 'commissions',
    nameKey: 'nav.admin.commissions',
    href: '/commissions',
    icon: 'M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z',
    permission: ['users.view', 'members.view'],
    route: '/commissions',
  },
  {
    id: 'settings',
    nameKey: 'nav.admin.settings',
    href: '/settings',
    icon: 'M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z',
    permission: 'settings.view',
    route: '/settings',
  },
  {
    id: 'modules',
    nameKey: 'nav.admin.modules',
    href: '/modules',
    icon: 'M11 4a2 2 0 114 0v1a1 1 0 001 1h3a1 1 0 011 1v3a1 1 0 01-1 1h-1a2 2 0 100 4h1a1 1 0 011 1v3a1 1 0 01-1 1h-3a1 1 0 01-1-1v-1a2 2 0 10-4 0v1a1 1 0 01-1 1H7a1 1 0 01-1-1v-3a1 1 0 00-1-1H4a2 2 0 110-4h1a1 1 0 001-1V7a1 1 0 011-1h3a1 1 0 001-1V4z',
    permission: 'settings.view',
    route: '/modules',
  },
  {
    id: 'stats',
    nameKey: 'nav.admin.statsAudits',
    href: '/admin',
    icon: 'M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z',
    permission: 'dashboard.stats_advanced',
    route: '/admin',
  },
  {
    id: 'ledgera',
    nameKey: 'nav.admin.ledgeraAdmin',
    href: '/admin/ledgera',
    icon: 'M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8V7m0 1v8m0 0v1m0-1a9 9 0 100-18 9 9 0 000 18z',
    permission: 'dashboard.stats_advanced',
    route: '/admin',
  },
];

export const MEMBER_BOTTOM_TAB_DEFS = [
  {
    id: 'dashboard',
    shortKey: 'navShort.dashboard',
    href: '/dashboard',
    icon: 'M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6',
  },
  {
    id: 'contributions',
    shortKey: 'navShort.contributions',
    href: '/contributions',
    icon: 'M17 9V7a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2m2 4h10a2 2 0 002-2v-6a2 2 0 00-2-2H9a2 2 0 00-2 2v6a2 2 0 002 2zm7-5a2 2 0 11-4 0 2 2 0 014 0z',
  },
  {
    id: 'allocations',
    shortKey: 'navShort.allocations',
    href: '/assistance',
    // Clipboard check — aligné avec l’action rapide Allocation
    icon: 'M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-6 9l2 2 4-4',
  },
];
